export default {
  //线索管理 获取列表数据
  GET_LIST: '/api/admin/clues/list'
}
